<template lang="pug">
tbody.vue-time-entries-weekly-copy-grid
  TimeEntriesWeeklyTableRow(
    v-for="(projectTask, index) in filteredProjectTasks"
    :key="index"
    :date-range="dateRange"
    :time-entries="getTimeEntriesForProjectTask(projectTask)"
    is-copy
    :project="getProject(projectTask[0])"
    :task="getTask(projectTask[1])"
  )
</template>
<script>
import { mapGetters } from 'vuex';

export default {
  name: 'TimeEntriesWeeklyCopyGrid',
  props: {
    dateRange: Array,
  },
  computed: {
    ...mapGetters(['filteredProjectTasks', 'getProject', 'getTask', 'inPlaceTimeEntries']),
  },
  methods: {
    getTimeEntriesForProjectTask(projectTask) {
      const projectId = projectTask[0];
      const taskId = projectTask[1];
      const timeEntries = this.inPlaceTimeEntries.filter(
        (timeEntry) => timeEntry.project_id === projectId && timeEntry.task_id === taskId,
      );

      return timeEntries;
    },
  },
};
</script>
